<template>
  <div>
    <HomeGallery @loaded="start" />
    <div class="main" :class="{ active }">
      <div class="title">
        <h2>Jérome Boutassime</h2>
        <h1>ORIGINALFAKE</h1>
        <p>scroll</p>
      </div>
      <div class="categories">
        <router-link to="/categories" tag="h3">Categories</router-link>
        <router-link
          v-for="{ name, slug } in categories"
          @mouseover.native="linkover(slug)"
          @mouseleave.native="linkover(null)"
          :key="slug"
          :to="`/category/${slug}`"
          >{{ name }}</router-link
        >
      </div>
      <div class="shootings">
        <router-link to="/shootings" tag="h3">Shootings</router-link>
        <router-link
          v-for="{ title, slug } in shootings"
          @mouseover.native="linkover(slug)"
          @mouseleave.native="linkover(null)"
          :key="slug"
          :to="`/shooting/${slug}`"
          >{{ title }}</router-link
        >
        <router-link to="/shootings" class="shootings-all">See all</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useQuery, useResult } from "@vue/apollo-composable";
import { ALL_LINKS } from "../queries";

import { ref } from "@vue/composition-api";

import HomeGallery from "../components/HomeGallery";

export default {
  name: "home",
  components: {
    HomeGallery,
  },
  setup() {
    const { result } = useQuery(ALL_LINKS, { number: 10 });
    const categories = useResult(result, null, (data) => data.categories.nodes);
    const shootings = useResult(result, null, (data) => data.posts.nodes);

    const active = ref(false);
    const start = () => (active.value = true);

    const linkover = (slug) => {
      if (slug) {
        const images = document.querySelectorAll(
          `.gallery .content:not(.${slug})`
        );
        images.forEach((img) => img.classList.remove("active"));
      } else {
        const images = document.querySelectorAll(".gallery .content");
        images.forEach((img) => img.classList.add("active"));
      }
    };

    return {
      active,
      start,
      categories,
      shootings,
      linkover,
    };
  },
};
</script>

<style lang="scss" scoped>
.main {
  @extend %container;

  position: relative;
  z-index: 1;
}

.title {
  margin: 50vh 0;
  text-align: center;
  transform: translateY(-50%);
}

.categories,
.shootings {
  margin-bottom: 25vh;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.8s 2s $ease-out;

  .active & {
    pointer-events: initial;
    opacity: 1;
  }
}

.shootings {
  text-align: right;

  &-all {
    @extend %font-regular;

    font-size: 0.8rem;
    letter-spacing: 0.2rem;
  }
}

h1 {
  @extend %font-bold;

  font-size: 3rem;
  line-height: 4rem;
  opacity: 0;
  color: $red;

  letter-spacing: 0.5rem;
  transition: opacity 0.8s 1.4s $ease-out, letter-spacing 1s 1.4s $ease-out;

  .active & {
    opacity: 1;
    letter-spacing: 0;
  }
}

h2,
p {
  @extend %font-regular;

  font-size: 0.6rem;
  letter-spacing: 0.7rem;
  opacity: 0;
  color: $black;

  .active & {
    opacity: 1;
    letter-spacing: 0.2rem;
  }
}

h2 {
  transition: opacity 0.8s 1s $ease-out, letter-spacing 1s 1s $ease-out;
}

p {
  transition: opacity 0.8s 1.8s $ease-out, letter-spacing 1s 1.8s $ease-out;
}

h3 {
  @extend %font-regular;

  color: $red;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  cursor: pointer;
}

a {
  @extend %font-bold;
  @extend %link;

  display: block;
  font-size: 2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
